var PhotogalleryV2 = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_photogalleryv2',
		first_image: null,
		width_by_thumbs: 5, //has to be odd or 0 if thumbs are hidden
		animate: false, //use for slideshow
		scroll_speed: 200,
		in_popup: false,
		thumbs: null, //used for full screen gallery
		show_controllers: false, //always display controllers
		missing_img: null,
		videos: false,
		show_floorplan: false,
		onFsClose: function() {
		}
	},

	initialize: function(element, options) {
		this.setOptions(options);
		this._element = element;
		this.cls = this.options.cls;
		this.verticalPadding = 10;
		if (this._element){
			this.build();
			this.adaFix();
		}
	},

	adaFix: function() {
		this._element.setAttribute('aria-label', 'carousel');
		this._element.setAttribute('role', 'region');
	},

	build: function() {
		var fcls = '.' + this.cls;
		this.lastScroll = 0;
		this.is_touched = false;
		this.normal_mode = true;
		this.fullscreen_mode = false;
		this._main = this._element.getElement(fcls + '_main');

		if (this.options.videos) {
			this._main.addClass('videos');
		}
		this._bottom = this._element.getElement(fcls + '_bottom');
		this._strip = this._element.getElement(fcls + '_strip');
		this._thumbs = this.options.thumbs || this._strip.getElements('.thumb');

		if (!this._thumbs || this._thumbs.length == 0) {
			this._element.dispose();
			return;
		}

		this.main_cont_width = this._main.getSize().x;
		this.main_cont_height = this._main.getSize().y;
		this.mainFullImgHeights = [];
		this.indexPositions = [];
		this.current_index = 0;
		
		var error_img_url = (this.options.missing_img) ? this.options.missing_img : Res_i + '/l/not-found-big-1.png';

		this._thumbs.each(function(_el, _index) {
			if (_el.getAttribute('type') === 'video') {
				_el._full_img = new Element('iframe', {
					class: 'iframe-fullscreen',
					'src': Res_i + '/l/dummy.png',
					'allowfullscreen': 1,
					'onerror': 'this.src=\'' + error_img_url + '\''
				});
			} else {
				_el._full_img = new Element('img', {
					'src': Res_i + '/l/dummy.png',
				});
			}

			_el._full_img_cont = new Element('div', {
				'class': 'full_img_cont'
			});
			if (_index != 0) {
				_el._full_img_cont.setStyles({'padding-top': '10px'});
			}
			_el._full_img_cont.adopt(_el._full_img);
			_el._full_img_cont.inject(this._main);

			var url = _el.getElement('img') ? _el.getElement('img').getAttribute('data-url') : null;

			if (url) {
				_el._full_img_cont.setStyle('cursor', 'pointer');

				_el._full_img_cont.addEvent('click', function() {
					window.location = url;
				});
			}
		}.bind(this));

		if (this._thumbs && this._thumbs.length < this.options.width_by_thumbs) {
			var dummies_amount = this.dummies_amount =	this.options.width_by_thumbs - this._thumbs.length;

			for (var i=0; i < dummies_amount; i++) {
				new Element('div', {'class': 'thumb _dummy', 'html': '&nbsp;'}).inject(this._strip);
			}
		}

		var _controllers = this._main.getElement(fcls + '_controllers');

		if (_controllers && this.options.show_controllers) {
			_controllers.show();
		}

		this._fullscreen = this._main.getElement(fcls + '_fullscreen');
		this._zoomin = this._main.getElement(fcls + '_zoomin');
		this._zoomout = this._main.getElement(fcls + '_zoomout');
		let _photogalleryContainer = document.getElement('.photogalleryv2_container');
		let _photogalleryContainerSize = null;
		if (!!_photogalleryContainer) {
			_photogalleryContainerSize = _photogalleryContainer.getSize();
		}
		if (!!_photogalleryContainerSize) {
			this._floorCurrentWidth = _photogalleryContainerSize.x - 600; // from PagePhotogalleryV2
			this._floorDefaultWidth = _photogalleryContainerSize.x - 600;
			this._floorMaxWidth = _photogalleryContainerSize.x + 600; 
			this._floorMinWidth = _photogalleryContainerSize.x - 1200;
		}
		
		if (!!this.options.show_floorplan) {
			if (!!this._zoomin) {
				this._zoomin.removeClass('none');
			}
			if (!!this._zoomout) {
				this._zoomout.removeClass('none');
			}
		} else {
			if (!!this._zoomin) {
				this._zoomin.addClass('none');
			}
			if (!!this._zoomout) {
				this._zoomout.addClass('none');
			}
		}
		if (!!this.options.videos == true) {
			if (!!this._fullscreen) {
				this._fullscreen.addClass('none');
			}
		} else {
			if (!!this._fullscreen) {
				this._fullscreen.removeClass('none');
			}
		}
		this._enlarge = this._main.getElement(fcls + '_enlarge');
		this._thumbs_left = this._element.getElement(fcls + '_bottom .move_left');
		this._thumbs_right = this._element.getElement(fcls + '_bottom .move_right');
		this._image_counter = this._element.getElement(fcls + '_image_counter');

		this._ajax_loader = new Element('div', {
			'class': 'ajax_loader',
			'html': '&nbsp;'
		});
		this._ajax_loader.inject(this._main, 'top');

		this.to_center = true;

		this.set_appearance();
		this.set_functionality();

		if (this._element.hasClass('_slide')) {
			this.move_caption();
		}
	},

	set_appearance: function(){
		var opts = this.options;

		if (opts.first_image && opts.first_image != '') {
			this._thumbs[0]._full_img.setProperty('src', opts.first_image);
			this._thumbs[0]._full_img_cont.fade('show');
		}

		if (opts.width_by_thumbs % 2 == 1) {
			this.margin = this._thumbs[0].getStyle('margin-left').toInt() + this._thumbs[0].getStyle('margin-right').toInt();
			this.thumb_width = this._thumbs[0].getSize().x;
			this.strip_width = (this.thumb_width + this.margin) * (this._thumbs.length + (this.dummies_amount || 0)) - this._thumbs[0].getStyle('margin-left').toInt();

			this.main_width = (this.thumb_width + this.margin) * opts.width_by_thumbs - this._thumbs[0].getStyle('margin-left').toInt();

			this._thumbs[0].setStyle('margin-left', 0);

			this._strip.setStyles({
				'width': this.strip_width,
				'left': 0
			});

		} else {
			this.main_width = this._main.getSize().x;

			var _bottom = this._element.getElement('.' + opts.cls + '_bottom');

			if (_bottom) {
				_bottom.hide();
				this._element.addClass('_no_thumbnails');
			}
		}

		if ((this.main_width == 0 || this.main_width == null) && opts.width) {
			this.main_width = opts.width;
		}
		
		this.main_height = this._main.getSize().y;

		if (opts.fullscreen) {
			this.img_cont_width = '100%';
			this.img_cont_height = '100%';
			this.main_height = '100%';
		} else {
			var _full_img_cont = this._thumbs[0]._full_img_cont;

			this.img_cont_width = this.main_width - _full_img_cont.getParent().getStyle('padding-left').toInt()*2 - _full_img_cont.getParent().getStyle('border-width').toInt()*2;
			this.img_cont_height = this.main_height - _full_img_cont.getParent().getStyle('padding-top').toInt()*2 - _full_img_cont.getParent().getStyle('border-width').toInt()*2;
		}

		var zi_1 = this._thumbs[0]._full_img_cont.getStyle('z-index').toInt();

		this._ajax_loader.setStyle('z-index', zi_1 + 1);
		this._ajax_loader.fade('hide');

		this._thumbs.each(function(_el, i) {
			_el.addEvent('click', function() {
				this.to_center = false;
				if (_el.getAttribute('type') == 'video') {
					this.select_video_thumb(i);
				} else {
					this.select_thumb(i);
				}
			}.bind(this));
		}.bind(this));
		this.thumbs_arrows_set_class();
	},

	set_functionality: function(){
		var self = this;

		this._main.addEvents({
			'mouseenter' : function() {
				self._main.addClass('_active');
			},

			'mouseover' : function() {
				self._main.addClass('_active');
			},

			'mouseout' : function() {
				self._main.removeClass('_active');
			},

			'click' : function() {
				var url = self._element.get('data-url') || self._thumbs[self.current_index].get("data-url");

				if(!url) return;

				window.location = url;
			},

			'scroll': function() {
				let currentScroll = self._main.scrollTop; // Get Current Scroll Value

				if (currentScroll > 0 && self.lastScroll <= currentScroll) {
					self.lastScroll = currentScroll;
					self.scrollDirection = 'down';
				} else {
					self.lastScroll = currentScroll;
					self.scrollDirection = 'up';
				}

				let indexFromMainScroll = self.getIndexFromMainScroll();
				
				if (indexFromMainScroll != self.current_index) {
					let th = self._thumbs[indexFromMainScroll];
					
					if (!!self._previous_thumb && self._previous_thumb !== th) {
						self._previous_thumb.removeClass('current');
					}

					if (!!th && self._previous_thumb !== th) {
						th.addClass('current');

						if (self.options.videos == true) {
							self.loadVideo(th, indexFromMainScroll);
						} else {
							self.load(th);
						}

						self.current_index = indexFromMainScroll;
						self.setImageCounter(indexFromMainScroll);
						self._previous_thumb = th;
						
						if (self.options.videos != true) {
							if (!!self.scrollDirection && self.scrollDirection == 'up') {
								self.loadAboveImage();
								self.loadSecondAboveImage();
							} else if (!!self.scrollDirection && self.scrollDirection == 'down') {
								self.loadBelowImage();
								self.loadSecondBelowImage();
							} else {
								self.loadAboveImage();
								self.loadSecondAboveImage();
								self.loadBelowImage();
								self.loadSecondBelowImage();
							}
						}

						self.move_thumbs_auto(indexFromMainScroll);
					}
				}
			}
		});

		if (this._fullscreen) {
			this._fullscreen.addEvents({
				'click': function(e) {
					if (e && e.stop) {
						e.stop();
					}
					if (self.fullscreen_mode) {
						this.go_normal_mode();
					} else {
						this.go_fullscreen_mode();
					}
				}.bind(this),

				'touchstart': function(e) {
					if(e && e.stop) e.stop();

					self._fullscreen.fireEvent('click');
					return false;
				}
			});
		}

		if (!!this._zoomin && !!this._zoomout && !!this.options.show_floorplan) {
			this._zoomin.addEvents({
				'click': function(e) {
					if (e && e.stop) {
						e.stop();
					}
					this.zoomin_floorplan();
				}.bind(this)				
			});

			this._zoomout.addEvents({
				'click': function(e) {
					if (e && e.stop) {
						e.stop();
					}
					this.zoomout_floorplan();
				}.bind(this)				
			});
		}

		if (this._thumbs.length == 1) {
			this.hide_controllers();
			return;
		}

		if (this.options.videos == true) {
			this._thumbs.each(function(_el, _index) {
				_el._full_img.addEvent('load',function() {
					self.mainFullImgHeights[_index] = _el._full_img.getSize().y + (_index > 0 ? self.verticalPadding : 0);
				});
			});
			this.select_video_thumb(0);
		} else {
			this.select_thumb(0);
		}
		
		if (this._thumbs.length > 1) {
			if (this._thumbs.length > this.options.width_by_thumbs) {
				this._thumbs_left.addEvent('click', function(e) {
					if (e && e.stop) e.stop();

					this.to_center = false;
					this.move_thumbs('left');
				}.bind(this));

				this._thumbs_right.addEvent('click', function(e) {
					if (e && e.stop) e.stop();

					this.to_center = false;
					this.move_thumbs('right');
				}.bind(this));

				this.move_strip = new Fx.Morph(this._strip, {
					link: 'ignore',
					duration: this.options.scroll_speed
				});
			} else {
				this._thumbs_left.hide();
				this._thumbs_right.hide();
			}
		}
	},

	select_thumb: function(index) {
		if (typeof(index) === 'string') {
			index = index.toInt();
		}

		var th = this._thumbs[index];

		if (index != 0 && !this.is_touched) {
			this.is_touched = true;
		}

		if (this._previous_thumb && this._previous_thumb !== th) {
			this._previous_thumb.removeClass('current');
		}

		if (!!th && this._previous_thumb !== this._thumbs[index]) {
			th.addClass('current');
			
			this.current_index = index;
			this.setImageCounter(index);
			this._previous_thumb = th;
			
			if (index == 0) {
				this.load(th);
				this.scrollMainToPosition(index);
			} else {
				this.loadAllAboveAndCurrentImages(index);
			}
			
			this.loadBelowImage();
			this.loadSecondBelowImage();
		}

		if (this.to_center == true && this.options.width_by_thumbs % 2 == 1) {
			this.move_thumbs_auto(index);
		}
	},

	select_video_thumb: function(index) {
		if (typeof(index) === 'string') {
			index = index.toInt();
		}

		var th = this._thumbs[index];

		if (this._previous_thumb && this._previous_thumb !== th) {
			this._previous_thumb.removeClass('current');
		}

		if (!!th && this._previous_thumb !== this._thumbs[index]) {
			th.addClass('current');
			this.current_index = index;
			this.setImageCounter(index);
			this._previous_thumb = th;
			this.loadVideo(th, index);
			this.scrollMainToPosition(index);
		}
	},

	scrollMainToPosition: function(index) {
		if (!!this.mainFullImgHeights && !!this.mainFullImgHeights.length) {
			var pos = 0;
			for (var i = 0; i < index; i++) {
				pos += this.mainFullImgHeights[i];
			}
			this._main.scrollTop = pos;
		}
	},

	getIndexFromMainScroll: function() {
		let _mainRect = this._main.getBoundingClientRect();
		let _mainTop = _mainRect.top;
		let foundIndex = this.current_index;

		for (let _index = 0; _index < this._thumbs.length; _index++) {
			let _el = this._thumbs[_index];
			let _elRect = _el._full_img.getBoundingClientRect();
			let _elTop = _elRect.top;
			let tmp = Math.round(_elTop);
			
			if (!this.fullscreen_mode) {
				if (_elTop > 0 && _elTop <= _mainTop) {
					foundIndex = _index;
					_index = this._thumbs.length;
				}
			} else {
				 if (tmp >= 0 && tmp <= 70) {
				 	foundIndex = _index;
				 	_index = this._thumbs.length;
				}
			}
		}
		
		return foundIndex;
	},

	load: function(th) {
		let path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
		this.hide_ajax_loader();
		this._current_full_img_cont = th._full_img_cont;
		this.update_caption(th);
		this.fireEvent('showImage');
	},

	loadVideo: function(th, index) {
		let src = th._full_img.get('src');
		if (src == Res_i + '/l/dummy.png') {
			let path = this.getThPathWithWidth(th);
			if (!!path) {
				th._full_img.set('src', path);
			}
			let error_img_url = th.getAttribute('data-error');
			if (!!error_img_url) {
				th._full_img.set('onerror', 'this.src = \'' + error_img_url + '\'');
			}
			
			this.hide_ajax_loader();
			this.fireEvent('showImage');
		}
	},

	getAboveTh: function() {
		let aboveTh = null;
		// not first
		if (this.current_index != 0) {
			aboveTh = this._thumbs[this.current_index - 1];
		}
		return aboveTh;
	},

	getSecondAboveTh: function() {
		let secondAboveTh = null;
		// not second
		if (this.current_index != 1) {
			secondAboveTh = this._thumbs[this.current_index - 2];
		}
		return secondAboveTh;
	},

	getBelowTh: function() {
		let belowTh = null;
		// not last
		if (this.current_index != this._thumbs.length - 1) {
			belowTh = this._thumbs[this.current_index + 1];
		}
		return belowTh;
	},

	getSecondBelowTh: function() {
		let secondBelowTh = null;
		// not before last
		if (this.current_index != this._thumbs.length - 2) {
			secondBelowTh = this._thumbs[this.current_index + 2];
		}
		return secondBelowTh;
	},

	getThPathWithWidth: function(th) {
		let path = null;
		if (!!th) {
			path = th.getAttribute('data-full');
		}
		return path;
	},

	loadImage: function(th, path) {
		let self = this;
		if (!!th && !!path) {
			new Asset.image(path, {
				onLoad: function() {
					th._full_img.set('src', path);
					self._thumbs.each(function(_el, _index) {
						self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
					});
				}
			});
		}
	},

	loadAboveImage: function() {
		let th = this.getAboveTh();
		let path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
	},

	loadSecondAboveImage: function() {
		let th = this.getSecondAboveTh();
		let path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
	},

	loadAllAboveAndCurrentImages: function(selectedThumbIndex) {
		let self = this;
		let myPromise = new Promise(function(myResolve, myReject) {
			// some code which takes time
			for (let i = 0; i <= selectedThumbIndex; i++) {
				let th = self._thumbs[i];
				let path = self.getThPathWithWidth(th);
				// this.loadImage(th, path, selectedThumbIndex);
				if (!!th && !!path) {
	
					new Asset.image(path, {
						onLoad: function() {
							th._full_img.set('src', path);
							
							self._thumbs.each(function(_el, _index) {
								self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
							});
							
							// if all images before selectedThumbIndex are loaded call myResolve
							let cntLoaded = 0;
							for (let ii = 0; ii <= selectedThumbIndex; ii++) {
								// default height is 11 (1 px + 10 px padding-top)
								if (self.mainFullImgHeights[ii] != 11) {
									cntLoaded++;
								}
							}
							
							if (cntLoaded == selectedThumbIndex + 1) {
								myResolve(selectedThumbIndex);
							}
						}
					});
				}
			}
		});
		  
		myPromise.then(
			function(selectedThumbIndex) {
				self.scrollMainToPosition(selectedThumbIndex);
			}
		);
	},

	loadBelowImage: function() {
		let th = this.getBelowTh();
		let path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
	},

	loadSecondBelowImage: function() {
		let th = this.getSecondBelowTh();
		let path = this.getThPathWithWidth(th);
		this.loadImage(th, path);
	},

	hide_ajax_loader: function() {
		this._ajax_loader.setStyles({
			opacity: 0,
			visibility: 'hidden'
		});
	},

	go_fullscreen_mode: function() {
		this.get_parent();
		this.normal_mode = false;
		this.fullscreen_mode = true;

		var self = this;
		this._fs_gallery = new Element('div', {'class': 'w_fs_gallery', 'aria-label': 'modal dialog', 'role': 'region'}).inject(document.body);
		var _fs_gallery_cont = new Element('div', {'class': 'w_fs_gallery_cont'}).inject(this._fs_gallery);
		var _fs_close = new Element('button', {'class': 'w_fs_close', 'html': 'Close'}).inject(_fs_gallery_cont);

		_fs_close.addEvent('click', function() {
			self.go_normal_mode();
		});

		this._element.inject(_fs_gallery_cont);
		
		if (!!this.options.show_floorplan) {
			this._floorCurrentWidth = this._floorDefaultWidth;
		}
		this._thumbs.each(function(_el, _index) {
			_el._full_img.setStyles({
				'width': '100%'
			});
			self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
		});

		this.scrollMainToPosition(this.current_index);

		this.removeTabbingRestriction = Core.disableTabbingOutside(this._fs_gallery);
		_fs_close.focus();
	},

	center_element: function(_element) {
		_element.setStyles({
			position: 'absolute'
		});

		var win_scroll = window.getScroll(),
			win_size = window.getSize(),
			el_size = _element.getSize();

		var pos_y = win_scroll.y + Math.floor(Math.max(0, (win_size.y - el_size.y)/2));

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			win_size.x = Math.max(win_size.x, document.getElement('body').offsetWidth);
		}

		var pos_x = win_scroll.x + Math.floor(Math.max(0, (win_size.x - el_size.x)/2));

		_element.setStyles({
			top: pos_y,
			left: pos_x
		});
	},

	get_parent: function() {
		this._parent = this._element.getParent();
	},

	restore_to_parent: function() {
		this._element.inject(this._parent);
	},

	go_normal_mode: function() {
		var self = this;
		this.restore_to_parent();
		var trigger;
		if (this._fs_gallery) {
			this._fs_gallery.destroy();
			this.fullscreen_mode = false;
			trigger = this._fullscreen;
		}
		if (this._veil) {
			this._veil.destroy();
		}
		if (this._en_gallery) {
			this._en_gallery.destroy();
			trigger = this._enlarge;
		}
		this.normal_mode = true;
		this.fireEvent('fsClose');

		if (!!this.options.show_floorplan) {
			this._main.setStyles({'overflow-x': 'hidden'});
		}

		this._thumbs.each(function(_el, _index) {
			_el._full_img.setStyles({
				'width': 'auto'
			});
			self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
		});

		this.scrollMainToPosition(this.current_index);
	
		trigger && trigger.focus();
		this.removeTabbingRestriction();
	},

	move_thumbs: function(side) {
		if (side=='left' && !this._thumbs_left.hasClass('inactive')) {
			var move = this._strip.getStyle('left').toInt() + (this.thumb_width + this.margin);
			if (move > 0) {
				move = 0;
			}
		} else if (side=='right' && !this._thumbs_right.hasClass('inactive')) {
			var move = this._strip.getStyle('left').toInt() - (this.thumb_width + this.margin);
		}

		if (!this.move_strip) return;

		if (move || move == 0) {
			this.move_strip.start({
				'left': move
			}).chain(function() {
				this.thumbs_arrows_set_class();
			}.bind(this));
		}
	},

	move_thumbs_auto: function(indx) {
		var half = Math.floor(this.options.width_by_thumbs/2);
		var thumb_to_center;

		if (this.options.width_by_thumbs < this._thumbs.length) {
			if (indx <= half) {
				thumb_to_center = 0;
			} else if (indx >= this._thumbs.length - half - 1) {
				thumb_to_center = this.main_width - this.strip_width;
			} else {
				thumb_to_center = -(this._strip.getSize().x - (this._thumbs.length - indx + half) * (this.thumb_width + this.margin) + this.margin);
			}

			if ((this._strip.getSize().x - (this.thumb_width*(indx))) < this._bottom.getSize().x) {
				thumb_to_center = -(this._strip.getSize().x - this._bottom.getSize().x);
			}

			if (!this.move_strip || (this.strip_width <= this._bottom.getSize().x)) {
				return;
			}

			this.move_strip.start({'left': thumb_to_center}).chain(function() {
				this.thumbs_arrows_set_class();
			}.bind(this));
		}
	},

	thumbs_arrows_set_class: function() {
		if (!this._strip) return;

		if (this._strip.getStyle('left').toInt() >= 0) {
			this._thumbs_left.addClass('inactive');
		} else {
			this._thumbs_left.removeClass('inactive');
		}

		if ((this.strip_width <= this.main_width) ||
			(this._bottom.getSize().x > (this._strip.getSize().x + this._strip.getStyle('left').toInt()))) {
			this._thumbs_right.addClass('inactive');
		} else {
			this._thumbs_right.removeClass('inactive');
		}
	},

	hide_controllers: function() {
		if (this.options.videos == true) {
			this.select_video_thumb(0);
		} else {
			this.select_thumb(0);
		}

		if (this._strip) {
			this._strip.getParent().hide();
			this._element.addClass('_no_thumbnails');
		}
	},

	update_caption: function(_th) {
		var _caption = this._element.getElement('.' + this.options.cls + '_caption span');

		if (!_caption) return;

		_caption.set('html', _th.getElement('img').get('title'));
	},

	move_caption: function() {
		var _caption = this._element.getElement('.' + this.options.cls + '_caption');

		if (!_caption) return;

		_caption.inject(this._element);
	},

	setImageCounter: function(indx) {
		if (this._image_counter) {
			this._image_counter.set('text', (this.current_index + 1) + ' / ' + this._thumbs.length + (!!this.options.videos ? ' Videos' : ' Photos'));
		}
	},

	zoomin_floorplan: function() {
		this._floorCurrentWidth += 200;
		if (this._floorCurrentWidth > this._floorMaxWidth) {
			this._floorCurrentWidth = this._floorMaxWidth;
		}
		this.zoomin_zoomout_floorplan_common();
		if (this._floorCurrentWidth > this._floorDefaultWidth) {
			this._main.setStyles({'overflow-x': 'scroll'});
		} else if (this._floorCurrentWidth <= this._floorDefaultWidth) {
			this._main.setStyles({'overflow-x': 'hidden'});
		}
	},

	zoomout_floorplan: function() {
		this._floorCurrentWidth -= 200;
		if (this._floorCurrentWidth < this._floorMinWidth) {
			this._floorCurrentWidth = this._floorMinWidth;
		}
		this.zoomin_zoomout_floorplan_common();
		if (this._floorCurrentWidth > this._floorDefaultWidth) {
			this._main.setStyles({'overflow-x': 'scroll'});
		} else if (this._floorCurrentWidth <= this._floorDefaultWidth) {
			this._main.setStyles({'overflow-x': 'hidden'});
		}
	},

	zoomin_zoomout_floorplan_common: function() {
		if (this._floorCurrentWidth == this._floorDefaultWidth) {
			if (this._thumbs.length == 1 && !!this._current_full_img_cont) {
				let _img = this._current_full_img_cont.getElement('img');
				_img.setStyles({
					'width': 'auto'
				});
			} else {
				let self = this;
				this._thumbs.each(function(_el, _index) {
					_el._full_img.setStyles({
						'width': 'auto'
					});
					self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
				});
			}
		} else {
			if (this._thumbs.length == 1 && !!this._current_full_img_cont) {
				let _img = this._current_full_img_cont.getElement('img');
				_img.setStyles({
					'width': this._floorCurrentWidth + 'px'
				});
			} else {
				let self = this;
				this._thumbs.each(function(_el, _index) {
					_el._full_img.setStyles({
						'width': self._floorCurrentWidth + 'px'
					});
					self.mainFullImgHeights[_index] = _el._full_img.height + (_index > 0 ? self.verticalPadding : 0);
				});
			}
		}
	}
});
